"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var swr_hooks_1 = require("@l2p/swr-hooks");
var react_1 = require("react");
var useSearchByValue_1 = __importDefault(require("./useSearchByValue"));
var IS_CATEGORY_MOBILE_OPEN = 'is_category_mobile_open';
var CURRENT_CATEGORY_MOBILE = 'current_category_mobile';
var useSearchBarMobile = function () {
    var _a;
    var _b = (0, swr_hooks_1.useCache)(), getDataFromCache = _b.getDataFromCache, setDataToCache = _b.setDataToCache;
    var closeModal = (0, apps_shared_1.useCloseModal)();
    var config = (0, swr_hooks_1.useConfig)();
    var isCategoryMode = Array.isArray(config === null || config === void 0 ? void 0 : config.searchBarMobileCategories) &&
        config.searchBarMobileCategories.length > 0;
    var _c = (0, react_1.useState)(getDataFromCache(IS_CATEGORY_MOBILE_OPEN) || false), isCategoriesOpened = _c[0], setCategoriesOpened = _c[1];
    var _d = (0, react_1.useState)(getDataFromCache(CURRENT_CATEGORY_MOBILE) || null), currentCategorySlug = _d[0], setCurrentCategorySlug = _d[1];
    var gamesByCategories = (0, swr_hooks_1.useGamesByCategories)().data;
    var geoData = (0, swr_hooks_1.useGeo)().data;
    var countryCode = (_a = geoData === null || geoData === void 0 ? void 0 : geoData.geoData) === null || _a === void 0 ? void 0 : _a.countryCode;
    var categorySlugs = (0, react_1.useMemo)(function () {
        if (!isCategoryMode)
            return [];
        var configCategories = config === null || config === void 0 ? void 0 : config.searchBarMobileCategories;
        if (!Array.isArray(configCategories))
            return [];
        return configCategories.filter(function (slug) { return typeof slug === 'string' && Boolean(slug); });
    }, [config === null || config === void 0 ? void 0 : config.searchBarMobileCategories, isCategoryMode]);
    var categoryKeys = (0, react_1.useMemo)(function () {
        return categorySlugs
            .map(function (slug) {
            return (0, apps_shared_1.getCategoryKeyWithGeo)({
                category: slug,
                gamesByCategories: gamesByCategories,
                countryCode: countryCode,
            });
        })
            .filter(function (key) { return Boolean(key); });
    }, [categorySlugs, gamesByCategories, countryCode]);
    var categories = (0, react_1.useMemo)(function () {
        return categoryKeys
            .map(function (key) { return gamesByCategories === null || gamesByCategories === void 0 ? void 0 : gamesByCategories[key]; })
            .filter(function (category) { return Boolean(category); });
    }, [categoryKeys, gamesByCategories]);
    var currentCategory = (0, react_1.useMemo)(function () {
        return isCategoryMode
            ? categories.find(function (category) { return category.slug === currentCategorySlug; }) ||
                null
            : null;
    }, [categories, currentCategorySlug, isCategoryMode]);
    var _e = (0, useSearchByValue_1.default)({ id: currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.id }), isSubmitting = _e.isSubmitting, games = _e.games, searchValue = _e.searchValue, handleSearchInputChange = _e.handleSearchInputChange, handleSearchInputClear = _e.handleSearchInputClear;
    var handleSetCurrentCategory = (0, react_1.useCallback)(function (category) {
        var slug = (category === null || category === void 0 ? void 0 : category.slug) || null;
        setCurrentCategorySlug(slug);
        setDataToCache(CURRENT_CATEGORY_MOBILE, slug);
    }, [setDataToCache]);
    (0, react_1.useEffect)(function () {
        if (!isCategoryMode)
            return;
        if (!categories.length)
            return;
        if (currentCategorySlug && !currentCategory) {
            handleSetCurrentCategory(null);
        }
    }, [
        categories,
        currentCategory,
        currentCategorySlug,
        handleSetCurrentCategory,
        isCategoryMode,
    ]);
    var handleClickOpenCategories = (0, react_1.useCallback)(function () {
        return setCategoriesOpened(function (prev) {
            setDataToCache(IS_CATEGORY_MOBILE_OPEN, !prev);
            return !prev;
        });
    }, [setCategoriesOpened, setDataToCache]);
    return {
        closeModal: closeModal,
        isCategoryMode: isCategoryMode,
        isCategoriesOpened: isCategoriesOpened,
        games: games,
        isSubmitting: isSubmitting,
        searchValue: searchValue,
        categories: categories,
        currentCategory: currentCategory,
        handleSearchInputChange: handleSearchInputChange,
        handleSearchInputClear: handleSearchInputClear,
        handleClickOpenCategories: handleClickOpenCategories,
        handleSetCurrentCategory: handleSetCurrentCategory,
    };
};
exports.default = useSearchBarMobile;
